export default "__VITE_ASSET__ce47543d__"